import Vue from 'vue'
import Router from 'vue-router'
import homePage from './homePage'
import { getLocalStorage, removeLocalStorage } from '@/utils/storage'

Vue.use(Router)

// 解决Vue路由重复导航错误
// 获取原型对象上的push函数
const originalPush = Router.prototype.push
// 修改原型对象中的push方法
Router.prototype.push = function push (location) {
  return originalPush.call(this, location).catch(err => err)
}

const routes = [
  ...homePage
]

const router = new Router({
  mode: 'history',
  routes,
  scrollBehavior (to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return { x: 0, y: 0 }
    }
  }
})
console.log(router)
router.beforeEach((to, from, next) => {
  // console.log('啊啊啊啊')
  // console.log(to)
  // console.log(from)
  if (to.meta.title) {
    document.title = to.meta.title
  } else {
    document.title = '顺福达物流'
  }
  next()
})
router.afterEach((to, from, next) => {
  // console.log('哈哈哈哈哈')
  // console.log(to)
  // console.log(from)
  if (to.path === '/bidding/detail') {
    let timer = setInterval(() => {
      // console.log(999999999)
      let title = getLocalStorage('detailTile')
      if (title) {
        document.title = title
        clearInterval(timer)
        removeLocalStorage('detailTile')
      }
    }, 100)
  }
})
export default router



// WEBPACK FOOTER //
// ./src/router/index.js